export const cartItemTelemedicine = (item) => {
  const reserveDataCode = item.reserveData.specialty?.code
  const specialtyCode = item.product.specialty

  return specialtyCode.reduce((acc, element) => {
    if (element.code === reserveDataCode) {
      acc = element.telemedicine
    }
    return acc
  }, false)
}
